export default "__VITE_ASSET__R2x3oOgN__"